var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"inner text-center"},[_c('b-spinner'),_vm._v(" "),_c('br'),_vm._v("\n        "+_vm._s(_vm.$t('loading.text'))+"\n    ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }